// Enterprise User Details Model
export class EnterpriseUser {
  constructor(data = {}) {
    this.userId = data.userId || data.user_id || '';
    this.email = data.email || '';
    this.firstName = data.firstName || data.first_name || '';
    this.lastName = data.lastName || data.last_name || '';
    this.isAdmin = data.isAdmin || data.is_admin || false;
    this.joinedAt = data.joinedAt || data.joined_at ? new Date(data.joinedAt || data.joined_at) : null;
    this.invitedBy = data.invitedBy || data.invited_by || null;
    this.lastActiveAt = data.lastActiveAt || data.last_active_at ? new Date(data.lastActiveAt || data.last_active_at) : null;
    this.reportsGenerated = data.reportsGenerated || data.reports_generated || 0;
  }
  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim() || this.email;
  }
}
